import * as types from '../const/action.types';
import { get, post, del } from '../api/_basic';

export function edit(name, list, todelete) {
    return async (dispatch) => {
        dispatch(listIsSaving(true));
        if (list && list.length > 0) {
            list.map(async (item) =>
                post(`${process.env.REACT_APP_API}/${name}`, { nombre: item.nombre })
                    .then((response) => {
                        dispatch(listIsSaving(false));
                        if (response.error !== undefined) {
                            throw Error(response);
                        }
                        return response.data;
                    })
                    .catch((error) => {
                        console.log(error);
                        throw error;
                    }),
            );
        }

        if (todelete && todelete.length > 0) {
            todelete.map((id) =>
                del(`${process.env.REACT_APP_API}/${name}/${id}`)
                    .then((response) => {
                        dispatch(listIsSaving(false));
                        if (response.error !== undefined) {
                            throw Error(response);
                        }
                        return response.data;
                    })
                    .catch((error) => {
                        console.log(error);
                        throw error;
                    }),
            );
        }
        return true;
    };
}

export function load(list) {
    return async function(dispatch) {
        dispatch(listsHasErrored(false, ''));
        dispatch(listsIsLoading(true));
        return get(`${process.env.REACT_APP_API}/${list}`)
            .then((response) => {
                dispatch(listsIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((item) => {
                dispatch(listsHasErrored(false, ''));
                dispatch(loadProductSuccess(item));
            })
            .catch((error) => {
                dispatch(listsHasErrored(error.type ? error.type : true, error.message));
            });
    };
}

export function loadProductSuccess(data) {
    return {
        type: types.LOAD_LIST_SUCCESS,
        data,
    };
}

export function listsHasErrored(bool, message) {
    return {
        type: types.LISTS_HAS_ERROR,
        hasErrored: bool,
        error: message,
    };
}

export function listsIsLoading(bool) {
    return {
        type: types.LISTS_IS_LOADING,
        isLoading: bool,
    };
}

export function listIsSaving(bool) {
    return {
        type: types.LISTS_IS_SAVING,
        isLoading: bool,
    };
}



// WEBPACK FOOTER //
// ./src/actions/list.actions.js